module.exports = __webpack_public_path__ + "images/emoji/loudspeaker.3ffbf64b9172f7de8e46.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/loudspeaker.png
// module id = WsBb
// module chunks = 14